import * as React from 'react'
import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import Box from '@mui/material/Box'
import ManageVendorNavigationItem from 'vendors/vendorAppBar/ManageVendorNavigationItem'
import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import { Link } from 'react-router-dom'
import { useMeVendors } from 'vendors/queries/useVendorUserQuery'
import { CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'

const AddCompany = styled(Box)(({ theme: { transitions, spacing } }) => ({
  padding: spacing(2),
  backgroundColor: '#F2F8FA',
  cursor: 'pointer',
  transition: transitions.create('background-color', {
    easing: transitions.easing.easeInOut,
    duration: transitions.duration.shorter
  }),
  '&:hover': {
    backgroundColor: '#F8FCFE'
  }
}))

const ManageVendorPopover: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isWidescreen = useMediaQuery(theme.breakpoints.up('md'))

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'manage-companies-popover' : undefined

  const { isLoading, data: vendors = [] } = useMeVendors()

  return (
    <>
      {isWidescreen ? (
        <Button sx={{ textTransform: 'none', ml: 3 }} onClick={handleClick}>
          <Typography sx={{ color: 'common.white' }}>{t('manage-companies')}</Typography>
          <KeyboardArrowDownIcon sx={{ color: 'common.white', ml: 1 }} />
        </Button>
      ) : (
        <IconButton onClick={handleClick}>
          <AccountTreeIcon sx={{ color: 'common.white' }} />
        </IconButton>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Stack divider={<Divider orientation="horizontal" flexItem />}>
          {isLoading ? (
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            vendors.map((vendor) => (
              <ManageVendorNavigationItem handleClose={handleClose} key={vendor.id} id={vendor.id} name={vendor.name} />
            ))
          )}
        </Stack>
        <Box component={Link} to={'/vendors/wizard/company'} sx={{ textDecoration: 'none', color: 'inherit' }}>
          <AddCompany>
            <Typography color="primary">{`+ ${t('add-new-company')}`}</Typography>
          </AddCompany>
        </Box>
      </Popover>
    </>
  )
}

export default ManageVendorPopover
